module.exports = __webpack_public_path__ + "static/media/lamborghini-go-drive.f33cba4c.png";